import './../AuthPages.scss';
import './ResetPasswordPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { clearCredentials, resetPassword, setResetPasswordData } from 'containers/Auth/store/actions';

import ResetPasswordForm from './ResetPasswordForm';
import Logo from 'components/Logo'

class ResetPasswordPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showSuccess: false
        };
    }

    componentWillMount() {
        document.body.classList.add('auth-page');
        const { token } = this.props.location.query;
        if (!token) {
            this.props.changeLocation('/login');
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
    }

    handleSubmit(formIsValid) {
        if(formIsValid === true) {
            const { token } = this.props.location.query;
            this.props.resetPassword(token)
                .then((res) => {
                    if(res.code >= 200 && res.code < 300) {
                        this.setState({showSuccess: true});
                    }
                })
        }
    }

    render() {
        return (
            <div className="auth--wrapper">
                <Logo
                    orientation="horizontal"
                />

                {this.state.showSuccess !== true ? (
                    <ResetPasswordForm
                        error={this.props.auth.resetPasswordError}
                        isResettingPassword={this.props.auth.isResettingPassword}
                        onValid={this.handleSubmit.bind(this, true)}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        resetPasswordData={this.props.auth.resetPasswordData}
                        setResetPasswordData={this.props.setResetPasswordData.bind(this)}
                    />
                ) : (
                    <div>
                        Your password has been reset. Please log into the Zisk app.
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearCredentials: () => dispatch(clearCredentials()),
        resetPassword: (token) => dispatch(resetPassword(token)),
        setResetPasswordData: (credentialsObj) => dispatch(setResetPasswordData(credentialsObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/ResetPasswordPage/index.js